// The street's sky: the shared outdoor sky (farm/outdoorSky.js) behind the street tiles, whose sky is cut out
// (street/streetLooks.mjs). The horizon is the street's tree line, so the sun and moon rise from and set behind the
// trees and roofs.
import { GAME_WIDTH } from '../config.js';
import { attachOutdoorSky } from '../farm/outdoorSky.js';
import { STREET_HORIZON_Y, streetSkyPanX } from './streetLooks.mjs';

// The street's visible sky is the band above its tree tops (world y ~0–250), so the clouds ride higher above the
// horizon than on the farm (backdropLayout CLOUD_ABOVE).
const CLOUD_ROWS = { far: { min: 250, max: 320 }, near: { min: 270, max: 360 } };

export function attachStreetSky(scene) {
  return attachOutdoorSky(scene, {
    horizonY: () => STREET_HORIZON_Y,
    // the clouds and the sun slide past as you walk (streetLooks.mjs STREET_SKY_PAN)
    panX: () => streetSkyPanX(scene.cameras.main.scrollX, GAME_WIDTH),
    cloudRows: CLOUD_ROWS,
  });
}
